import React from 'react'

const NitradingEntry = () => {
  return (
    <div>NitradingEntry</div>
  )
}

export default NitradingEntry